// ======================================================
// REHBER360 — KOÇLUK ORTAK VERİ KATALOĞU
// ======================================================
// Bu dosya ileride:
// - AI Makro Plan
// - Akıllı Plan Robotu
// - Manuel Programlama
// tarafından ortak kullanılacak veri katmanıdır.
// ======================================================

export const RUTIN_SECENEKLERI = [
  // --- YKS RUTİNLERİ ---
  "1. Temel Odak (20 Paragraf + 20 Problem)",
  "2. Kapsamlı TYT (20 Prg + 20 Prb + 10 Geo)",
  "3. Sınav Kondisyonu (Günlük TYT Branş Denemesi)",
  "4. Sözel/EA Dengeleyici (30 Prg + 15 Dil Bilgisi)",
  "5. Sayısal İleri (20 Prb + 10 Geo + 15 TYT Fen)",
  "6. Isınma/Okul Günü (15 Prg veya 15 Prb)",
  "7. Son Viraj/Kamp (Her gün 1 Tam Genel Deneme)",
  "8. Sözel Bilgi Deposu (20 Prg + 20 Edb/Tar)",

  // --- LGS RUTİNLERİ ---
  "9. LGS Temel (20 Sayfa Kitap + 15 Paragraf + 15 Yeni Nesil Mat)",
  "10. LGS Okuma & Yorum (30 Sayfa Kitap + 20 Paragraf + 15 Fen)",
  "11. LGS Sayısal Zırh (20 Yeni Nesil Mat + 20 Fen)",
  "12. LGS Sözel Zırh (20 İnkılap + 20 Türkçe + 15 İngilizce)",
  "13. LGS Isınma (20 Sayfa Kitap veya 20 Paragraf)",
  "14. Diğer (Manuel Giriş)"
];



export const mufredatVerisi = {
  // Manuel planlamada kolaylık için hazır rutinler
  "⭐ GÜNLÜK RUTİNLER": RUTIN_SECENEKLERI,

  // ======================================================
  // TYT
  // ======================================================

  "TYT - Türkçe": [
    "Sözcükte Anlam",
    "Cümlede Anlam",
    "Paragrafta Anlam",
    "Anlatım Biçimleri",
    "Ses Bilgisi",
    "Yazım Kuralları",
    "Noktalama İşaretleri",
    "Sözcükte Yapı",
    "Sözcük Türleri",
    "Edat-Bağlaç-Ünlem",
    "Fiiller",
    "Ek Fiil",
    "Fiilde Çatı",
    "Fiilimsi",
    "Cümlenin Öğeleri",
    "Cümle Türleri",
    "Anlatım Bozuklukları"
  ],

  "TYT - Matematik": [
    "Sayılar",
    "Sayı Basamakları",
    "Bölme ve Bölünebilme",
    "OBEB-OKEK",
    "Rasyonel Sayılar",
    "Basit Eşitsizlikler",
    "Mutlak Değer",
    "Üslü Sayılar",
    "Köklü Sayılar",
    "Çarpanlara Ayırma",
    "Oran Orantı",
    "Denklem Çözme",
    "Problemler",
    "Kümeler",
    "Fonksiyonlar",
    "Permütasyon",
    "Kombinasyon",
    "Binom",
    "Olasılık",
    "İstatistik",
    "2. Dereceden Denklemler",
    "Karmaşık Sayılar",
    "Polinomlar"
  ],

  "TYT - Geometri": [
    "Doğruda ve Üçgende Açılar",
    "Üçgende Açı-Kenar Bağıntıları",
    "Üçgende Benzerlik",
    "Üçgende Açıortay-Kenarortay",
    "Dik Üçgen",
    "İkizkenar Üçgen",
    "Eşkenar Üçgen",
    "Üçgende Alan",
    "Çokgenler",
    "Dörtgenler",
    "Yamuk-Paralelkenar",
    "Eşkenar Dörtgen",
    "Dikdörtgen",
    "Kare",
    "Deltoid",
    "Çemberde Açı",
    "Çemberde Uzunluk",
    "Dairenin Çevresi ve Alanı",
    "Doğrunun Analitik İncelenmesi",
    "Çemberin Analitik İncelenmesi",
    "Katı Cisimler"
  ],

  "TYT - Tarih": [
    "Tarih Bilimine Giriş",
    "Uygarlığın Doğuşu ve İlk Uygarlıklar",
    "İlk Türk Devletleri",
    "İslam Tarihi ve Uygarlığı",
    "Türk-İslam Devletleri",
    "Türkler'in İslamiyeti Kabulü",
    "Türkiye Tarihi",
    "Beylikten Devlete (1300-1453)",
    "Dünya Gücü: Osmanlı Devleti",
    "Osmanlı Duraklama Dönemi",
    "Gerileme Devri (1699-1792)",
    "Arayış Yılları (17. Yüzyıl)",
    "Avrupa ve Osmanlı Devleti (18. Yüzyıl)",
    "En Uzun Yüzyıl (1800-1922)",
    "20.Yüzyıl Başlarında Osmanlı Devleti",
    "XIX. YY Osmanlı Devleti",
    "1.Dünya Savaşı - Milli Mücadeleye Hazırlık D.",
    "Kurtuluş Savaşında Cepheler",
    "Türk İnkılabı",
    "Atatürkçülük ve Atatürk İlkeleri",
    "Türk Dış Politikası"
  ],

  "TYT - Coğrafya": [
    "İnsan ve Coğrafya",
    "Dünya'nın Şekli ve Hareketleri",
    "Harita Bilgisi",
    "Coğrafi Konum",
    "Dünya'nın Yapısı ve Oluşum Süreci",
    "Su Kaynakları-Toprak-Bitkiler",
    "İklim Bilgisi",
    "Nüfus-Türkiye'de Nüfus",
    "Göç",
    "Ekonomik Faaliyetler",
    "Ülkeler ve Bölgeler",
    "Çevre ve Toplum"
  ],

  "TYT - Fizik": [
    "Fizik Bilimine Giriş",
    "Madde ve Özellikleri",
    "Sıvıların Kaldırma Kuvveti",
    "Basınç",
    "Isı, Sıcaklık ve Genleşme",
    "Hareket ve Kuvvet",
    "Dinamik",
    "İş, Güç ve Enerji",
    "Elektrik",
    "Manyetizma",
    "Optik"
  ],

  "TYT - Kimya": [
    "Kimya Bilimi",
    "Atom ve Yapısı",
    "Periyodik Sistem",
    "Kimyasal Türler Arası Etkileşimler",
    "Asitler-Bazlar ve Tuzlar",
    "Doğa ve Kimya",
    "Kimyasal Tepkimeler",
    "Kimyanın Temel Yasaları",
    "Maddenin Halleri",
    "Karışımlar",
    "Endüstride ve Canlılarda Enerji",
    "Kimya Her Yerde"
  ],

  "TYT - Biyoloji": [
    "Canlıların Ortak Özellikleri",
    "Canlıların Temel Bileşenleri",
    "Hücre ve Organelleri",
    "Hücre Zarından Madde Geçişi",
    "Canlıların Sınıflandırılması",
    "Mitoz ve Eşeysiz Üreme",
    "Mayoz ve Eşeyli Üreme",
    "Kalıtım",
    "Ekosistem Ekolojisi",
    "Güncel Çevre Sorunları"
  ],

  "TYT - Din Kültürü": [
    "İnsan ve Din (İnanç)",
    "İbadet",
    "Hz. Muhammed'in Hayatı",
    "Vahiy ve Akıl",
    "İslam Düşüncesi ve Yorumu",
    "İslamda Değerler, Sanat ve Laiklik",
    "Yaşayan Dinler"
  ],

  "TYT - Felsefe": [
    "Felsefe'nin Alanı",
    "Bilgi Felsefesi",
    "Bilim Felsefesi",
    "Varlık Felsefesi",
    "Ahlak Felsefesi",
    "Siyaset Felsefesi",
    "Sanat Felsefesi",
    "Din Felsefesi"
  ],

  // ======================================================
  // AYT
  // ======================================================

  "AYT - Matematik (İleri)": [
    "Kartezyen Çarpım",
    "Mantık",
    "2.Dereceden Eşitsizlikler",
    "Parabol",
    "Trigonometri",
    "Logaritma",
    "Diziler",
    "Limit",
    "Türev",
    "İntegral"
  ],

  "AYT - Geometri (İleri)": [
    "Prizmalar",
    "Piramitler",
    "Küre",
    "Koordinat Düzlemi ve Noktanın Analitiği",
    "Tekrar Eden, Dönen ve Yansıyan Şekiller",
    "Dönüşümlerle Geometri"
  ],

  "AYT - Edebiyat": [
    "Şiir Bilgisi",
    "Düzyazı Türleri",
    "İslamiyet Öncesi Türk Edebiyatı",
    "İslami Dönem İlk Dil ve Edebiyat Ürünleri",
    "Divan Edebiyatı",
    "Halk Edebiyatı",
    "Edebî Akımlar",
    "Tanzimat Edebiyatı",
    "Servetifûnun Edebiyatı",
    "Fecr-i Ati Edebiyatı",
    "Milli Edebiyat",
    "Cumhuriyet Şiiri",
    "Cumhuriyet Romanı",
    "Cumhuriyet Dönemi",
    "Dünya Edebiyatı",
    "Çağdaş Türk Edebiyatı",
    "Eser Özetleri"
  ],

  "AYT - Fizik (İleri)": [
    "Vektörler",
    "Kuvvet, Tork ve Denge",
    "Kütle Merkezi",
    "Basit Makineler",
    "Newton'un Hareket Yasaları",
    "İş, Güç ve Enerji II",
    "Atışlar",
    "İtme ve Momentum",
    "Elektrik Alan ve Potansiyel",
    "Paralel Levhalar ve Sığa",
    "Manyetik Alan ve Manyetik Kuvvet",
    "İndüksiyon, Alternatif Akım ve Transformatörler",
    "Çembersel Hareket",
    "Kütle Çekim ve Kepler Yasaları",
    "Basit Harmonik Hareket",
    "Dalga Mekaniği ve Elektromanyetik Dalgalar",
    "Atom Modelleri",
    "Büyük Patlama ve Radyoaktivite",
    "Modern Fizik",
    "Modern Fiziğin Teknolojideki Uygulamaları"
  ],

  "AYT - Kimya (İleri)": [
    "Modern Atom Teorisi",
    "Gazlar",
    "Sıvı Çözeltiler ve Çözünürlük",
    "Kimyasal Tepkimelerde Enerji",
    "Tepkimelerde Hız ve Denge",
    "Kimya ve Elektrik",
    "Karbon Kimyası",
    "Organik Kimya",
    "Enerji Kaynakları ve Bilimsel Gelişmeler"
  ],

  "AYT - Biyoloji (İleri)": [
    "Sinir Sistemi",
    "Endokrin Sistem",
    "Duyu Organları",
    "Destek ve Hareket Sistemi",
    "Sindirim Sistemi",
    "Dolaşım ve Bağışıklık Sistemi",
    "Solunum Sistemi",
    "Üriner Sistem",
    "Üreme Sistemi ve Embriyonik Gelişim",
    "Komünite ve Popülasyon Ekolojisi",
    "Nükleik Asitler",
    "Genetik Şifre ve Protein Sentezi",
    "Canlılık ve Enerji",
    "Fotosentez ve Kemosentez",
    "Hücresel Solunum",
    "Bitki Biyolojisi",
    "Canlılar ve Çevre"
  ],

  "AYT - Tarih (İleri)": [
    "İslam Öncesi Türk Tarihi",
    "İlk Türk İslam Devletleri",
    "Orta Çağ'da Avrupa",
    "Yeni ve Yakın Çağ'da Avrupa",
    "Yüzyıl Değişim ve Diploması",
    "Osmanlı Kültür ve Medeniyeti",
    "Birinci Dünya Savaşı",
    "İnkılap Tarihi Tüm Konular",
    "Yüzyıl Başlarında Dünya",
    "İkinci Dünya Savaşı",
    "Soğuk Savaş Dönemi",
    "Yumuşama Dönemi",
    "Küreselleşen Dünya"
  ],

  "AYT - Coğrafya (İleri)": [
    "Beşeri Sistemler",
    "Mekansal Bir Sentez: Türkiye",
    "Türkiye'de Tarım ve Hayvancılık",
    "Türkiye'nin Bölgeleri ve Bölgesel Kalkınma Projeleri",
    "Küresel Ortam: Bölgeler ve Ülkeler",
    "Ülkeler Coğrafyası",
    "Ekosistem ve Madde Döngüleri",
    "Çevre ve İnsan",
    "Doğal Afetler"
  ],

  "AYT - Psikoloji": [
    "Psikoloji Bilimini Tanıyalım",
    "Psikolojinin Temel Süreçleri",
    "Öğrenme Bellek Düşünme",
    "Ruh Sağlığının Temelleri"
  ],

  "AYT - Sosyoloji": [
    "Sosyolojiye Giriş",
    "Birey ve Toplum",
    "Toplumsal Yapı",
    "Toplumsal Değişme ve Gelişme",
    "Toplum ve Kültür",
    "Toplumsal Kurumlar"
  ],

  "AYT - Mantık": [
    "Mantığa Giriş",
    "Klasik Mantık",
    "Mantık ve Dil",
    "Sembolik Mantık"
  ],

  "AYT - Din Kültürü (İleri)": [
    "Dünya ve Ahiret",
    "Kur'an'a Göre Hz. Muhammed",
    "Kur'an'da Bazı Kavramlar",
    "Kur'an'dan Mesajlar",
    "İnançla İlgili Meseleler",
    "İslam ve Bilim",
    "Anadolu'da İslam",
    "İslam Düşüncesinde Tasavvufi Yorumlar ve Mezhepler",
    "Güncel Dini Meseleler"
  ],

  // ======================================================
  // LGS
  // ======================================================

  "LGS - Türkçe": [
    "Fiilimsiler",
    "Cümlenin Ögeleri",
    "Cümle Türleri",
    "Sözcükte Anlam",
    "Cümlede Anlam ve Yorumlama",
    "Paragrafta Anlam ve Yapı",
    "Tablo, Grafik ve Görsel Yorumlama",
    "Sözel Mantık (Akıl Yürütme)",
    "Metin Türleri",
    "Söz Sanatları",
    "Yazım Kuralları",
    "Noktalama İşaretleri",
    "Fiillerde Çatı",
    "Anlatım Bozuklukları"
  ],

  "LGS - Matematik": [
    "Çarpanlar ve Katlar",
    "Üslü İfadeler",
    "Kareköklü İfadeler",
    "Veri Analizi",
    "Basit Olayların Olma Olasılığı",
    "Cebirsel İfadeler ve Özdeşlikler",
    "Doğrusal Denklemler",
    "Eşitsizlikler",
    "Üçgenler",
    "Eşlik ve Benzerlik",
    "Geometrik Cisimler",
    "Dönüşüm Geometrisi"
  ],

  "LGS - Fen Bilimleri": [
    "Mevsimler ve İklimler",
    "DNA ve Genetik Kod",
    "Basınç",
    "Madde ve Endüstri",
    "Periyodik Sistem",
    "Fiziksel ve Kimyasal Değişimler",
    "Asitler ve Bazlar",
    "Basit Makineler",
    "Canlılar ve Enerji İlişkileri",
    "Enerji Dönüşümleri ve Çevre Bilimi",
    "Elektrik Yükleri ve Elektrik Enerjisi"
  ],

  "LGS - İnkılap Tarihi": [
    "Bir Kahraman Doğuyor",
    "Milli Uyanış: Bağımsızlık Yolunda",
    "Milli Bir Destan; Ya İstiklal Ya Ölüm",
    "Çağdaş Türkiye Yolunda Adımlar",
    "Demokratikleşme Çabaları",
    "Atatürkçülük",
    "Türk Dış Politikası ve Atatürk’ün Ölümü",
    "İkinci Dünya Savaşı Ve Sonrası"
  ],

  "LGS - İngilizce": [
    "Friendship",
    "Teen Life",
    "In the Kitchen",
    "On the Phone",
    "The Internet",
    "Adventures",
    "Tourism",
    "Chores",
    "Science",
    "Natural Forces"
  ],

    "LGS - Din Kültürü": [
    "Kader ve Kaza İnancı",
    "Zekât ve Sadaka İbadeti",
    "Din, Birey ve Toplum",
    "Hz. Muhammed ve Örnekliği",
    "Kur’an-ı Kerim ve Özellikleri"
  ],

  // ======================================================
  // DHBT
  // ======================================================

  "DHBT-1": [
    "Kur'an-ı Kerim ve Tecvid",
    "Akaid ve Kelam",
    "Fıkıh ve İbadetler",
    "Siyer ve İslam Tarihi",
    "Hadis ve Tefsir"
  ],

  "DHBT-2": [
    "Tefsir",
    "Fıkıh (İslam Hukuku)",
    "Hadis",
    "Akaid ve Kelam",
    "İslam Tarihi",
    "Dinler ve Mezhepler Tarihi",
    "Dinî Hitabet ve Mesleki Bilgi"
  ]
};



// ======================================================
// AKTİF MÜFREDAT KATALOĞU
// ======================================================

export const MUFREDAT_MODELLERI = {
  MEVCUT: "legacy",
  MAARIF: "maarif"
};


export const getMufredatVerisi =
  (
    curriculumModel =
      MUFREDAT_MODELLERI.MEVCUT
  ) => {

    if (
      curriculumModel !==
        MUFREDAT_MODELLERI.MAARIF
    ) {
      return mufredatVerisi;
    }


    return {

      ...mufredatVerisi,

      ...maarifMufredatOverrides
    };
  };



// ======================================================
// TÜRKİYE YÜZYILI MAARİF MODELİ
// REHBER360 MAARİF KONU OVERRIDE'LARI
// ======================================================
//
// NOT:
//
// Bu yapı ÖSYM'nin resmî TYT / AYT konu dağılımı değildir.
//
/// Rehber360 ürün mimarisinde ders türüne göre
// koçluk odaklı bir eşleme uygulanır:
//
// Matematik / Geometri:
//   9-10. sınıf ağırlıklı içerikler → TYT / temel havuz
//   11-12. sınıf ağırlıklı içerikler → AYT / ileri havuz
//
// Türk Dili ve Edebiyatı:
//   TYT Türkçe → anlam, okuma, anlatım ve dil bilgisi havuzu
//   AYT Edebiyat → 9-12. sınıf edebiyat türleri,
//                  gelenekleri ve dönemlerini kapsayan ileri havuz
//
// Bu ayrım ÖSYM'nin resmî konu sınıflaması değil,
// Rehber360'ın koçluk amaçlı ürün eşlemesidir.
//
// Mevcut subject anahtarları korunur.
// Böylece Smart Plan motorunun:
//
// - selectedSubjects
// - subjectPriorities
// - selectedTopics
// - scheduler
// - validator
//
// sözleşmeleri değişmez.
// ======================================================

export const maarifMufredatOverrides = {

  // ====================================================
  // TYT / TÜRKÇE
  //
  // TYMM Türk Dili ve Edebiyatı programındaki
  // anlam, metin çözümleme ve dil yapıları;
  // TYT koçluk diline dönüştürülmüştür.
  //
  // NOT:
  // Bu liste ÖSYM'nin resmî TYT konu listesi değildir.
  // ====================================================

  "TYT - Türkçe": [

    // -------------------------
    // ANLAM / OKUMA
    // -------------------------

    "Sözcükte Anlam",

    "Cümlede Anlam",

    "Paragrafta Anlam ve Yapı",

    "Ana Düşünce ve Yardımcı Düşünce",

    "Paragrafta Anlatım Teknikleri",

    "Metinler Arası İlişki ve Karşılaştırma",


    // -------------------------
    // ANLATIM / METİN
    // -------------------------

    "Anlatım Biçimleri",

    "Düşünceyi Geliştirme Yolları",

    "Metin Türleri ve Anlatım Özellikleri",


    // -------------------------
    // DİL BİLGİSİ
    // -------------------------

    "Ses Bilgisi",

    "Yazım Kuralları",

    "Noktalama İşaretleri",

    "Sözcükte Yapı",

    "Sözcük Türleri",

    "Edat, Bağlaç ve Ünlem",

    "Fiiller, Ek Fiil ve Fiilde Çatı",

    "Fiilimsi",

    "Cümlenin Öğeleri ve Cümle Türleri",

    "Anlatım Bozuklukları"
  ],


  // ====================================================
  // TYT / TEMEL MATEMATİK
  // 9 + 10. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "TYT - Matematik": [

    // -------------------------
    // 9. SINIF — SAYILAR
    // -------------------------

    "Gerçek Sayılar ve Sayı Kümeleri",

    "Üslü ve Köklü Gösterimler",

    "Bilimsel Gösterim",

    "Gerçek Sayı Aralıkları ve Küme İşlemleri",


    // -------------------------
    // 9. SINIF — FONKSİYON
    // -------------------------

    "Doğrusal Fonksiyonlar",

    "Mutlak Değer Fonksiyonu",

    "Doğrusal Denklem ve Eşitsizlik Problemleri",


    // -------------------------
    // 9. SINIF — ALGORİTMA
    // -------------------------

    "Algoritma Temelli Problemler",

    "Mantık Bağlaçları ve Niceleyiciler",


    // -------------------------
    // 9. SINIF — İSTATİSTİK
    // -------------------------

    "Tek Nicel Değişkenli Veriler",

    "Histogram ve Kutu Grafiği",

    "Merkezî Eğilim ve Yayılım Ölçüleri",


    // -------------------------
    // 9. SINIF — OLASILIK
    // -------------------------

    "Deneysel ve Teorik Olasılık",


    // -------------------------
    // 10. SINIF — SAYILAR
    // -------------------------

    "Asal Çarpanlar ve Bölenler",

    "EBOB - EKOK",

    "Bölünebilme",


    // -------------------------
    // 10. SINIF — FONKSİYON
    // -------------------------

    "Fonksiyon Olma Şartları",

    "Karesel Fonksiyonlar ve Parabol",

    "Karekök Fonksiyonu",

    "Rasyonel Fonksiyonlar",

    "Ters Fonksiyon",

    "Fonksiyonlarla Denklem ve Eşitsizlik Problemleri",


    // -------------------------
    // 10. SINIF — SAYMA
    // -------------------------

    "Sayma Stratejileri",

    "Faktöriyel",

    "Sıralama ve Seçme Problemleri",

    "Cebirsel ve Fonksiyonel İşlemlerde Algoritma",


    // -------------------------
    // 10. SINIF — İSTATİSTİK
    // -------------------------

    "İki Kategorik Değişkenli Veriler",


    // -------------------------
    // 10. SINIF — OLASILIK
    // -------------------------

    "Koşullu Olasılık",

    "Bayes Teoremi"
  ],


  // ====================================================
  // TYT / TEMEL GEOMETRİ
  // 9 + 10. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "TYT - Geometri": [

    // -------------------------
    // 9. SINIF
    // -------------------------

    "Üçgende Açı ve Kenar İlişkileri",

    "Üçgen Eşitsizliği",

    "Geometrik Dönüşümler",

    "Üçgenlerde Eşlik",

    "Üçgenlerde Benzerlik",

    "Tales Teoremi",

    "Öklid Teoremi",

    "Pisagor Teoremi",


    // -------------------------
    // 10. SINIF
    // -------------------------

    "Dik Üçgende Trigonometrik Oranlar",

    "Trigonometrik Özdeşlikler",

    "Üçgende Yardımcı Elemanlar",

    "Üçgenin Alanı",

    "Sinüs Teoremi",

    "Kosinüs Teoremi",

    "Analitik Düzlemde Nokta",

    "Doğrunun Analitik İncelenmesi"
  ],


  // ====================================================
  // AYT / İLERİ MATEMATİK
  // 11 + 12. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "AYT - Matematik (İleri)": [

    // -------------------------
    // 11. SINIF — İSTATİSTİK
    // -------------------------

    "İki Nicel Değişkenli Veriler",

    "Serpme Diyagramı ve Korelasyon",


    // -------------------------
    // 11. SINIF — TRİGONOMETRİ
    // -------------------------

    "Trigonometrik Fonksiyonlar",

    "Trigonometrik Denklemler",


    // -------------------------
    // 11. SINIF — ÜSTEL / LOGARİTMA
    // -------------------------

    "Üstel Fonksiyonlar",

    "Logaritmik Fonksiyonlar",

    "Üstel ve Logaritmik Denklem ve Eşitsizlik Problemleri",


    // -------------------------
    // 11. SINIF — FONKSİYON
    // -------------------------

    "Bileşke Fonksiyon",

    "Fonksiyonlarda Dört İşlem",


    // -------------------------
    // 12. SINIF — DİZİLER
    // -------------------------

    "Aritmetik Diziler",

    "Geometrik Diziler",


    // -------------------------
    // 12. SINIF — POLİNOM
    // -------------------------

    "Polinom Fonksiyonlar",

    "Polinom ve Rasyonel Fonksiyonlarla Denklem ve Eşitsizlikler",


    // -------------------------
    // 12. SINIF — LİMİT
    // -------------------------

    "Limit",

    "Süreklilik",


    // -------------------------
    // 12. SINIF — TÜREV
    // -------------------------

    "Türev",

    "Türev Alma Kuralları",

    "Türevin Geometrik Yorumu",

    "Türev Uygulamaları"

    // İNTEGRAL BİLEREK YOKTUR.
  ],


  // ====================================================
  // AYT / İLERİ GEOMETRİ
  // 11 + 12. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "AYT - Geometri (İleri)": [

    // -------------------------
    // 11. SINIF
    // -------------------------

    "Dörtgenlerin Özellikleri",

    "Özel Dörtgenler",

    "Çokgenlerin Sınıflandırılması",

    "Dışbükey Çokgenlerin Özellikleri",

    "Çokgen Problemleri",


    // -------------------------
    // 12. SINIF — ÇEMBER
    // -------------------------

    "Çemberin Elemanları",

    "Çemberde Açı, Kiriş ve Teğet",

    "Çember ve Daire Problemleri",


    // -------------------------
    // 12. SINIF — CİSİMLER
    // -------------------------

        "Dik Prizma ve Dik Dairesel Silindir",

    "Dik Piramit, Dik Dairesel Koni ve Küre",

    "Geometrik Cisimlerde Alan ve Hacim Problemleri"
  ],


  // ====================================================
  // AYT / EDEBİYAT
  //
  // TYMM 9-12 Türk Dili ve Edebiyatı programındaki
// edebiyat türleri, gelenekleri, dönemleri ve temel
// metin türlerinin Rehber360 YKS koçluk diline
// dönüştürülmüş konu havuzudur.
  //
  // NOT:
  // Bu liste ÖSYM'nin resmî AYT konu dağılımı değildir.
  // ====================================================

  "AYT - Edebiyat": [

    // -------------------------
    // TEMEL EDEBİYAT / TÜRLER
    // -------------------------

    "Edebiyatın Temel Kavramları ve Metin Tahlili",

    "Şiir Bilgisi ve Ahenk Unsurları",

    "Hikâye ve Roman",

    "Tiyatro",

    "Öğretici Metin Türleri",


    // -------------------------
    // ESKİ TÜRK EDEBİYATI
    // -------------------------

    "Sözlü Kültür ve İslamiyet Öncesi Türk Edebiyatı",

    "Orhun Abideleri",

    "Geçiş Dönemi Eserleri: Kutadgu Bilig ve Dîvânu Lugâti't-Türk",


    // -------------------------
    // HALK / DİVAN GELENEĞİ
    // -------------------------

    "Halk Edebiyatı ve Âşık Tarzı Şiir",

    "Destan, Dede Korkut ve Halk Hikâyeleri",

    "Divan Edebiyatı",

    "Gazel, Kaside ve Mesnevi",


    // -------------------------
    // BATI ETKİSİNDE GELİŞEN
    // TÜRK EDEBİYATI
    // -------------------------

    "Tanzimat Edebiyatı",

    "Servetifünun Edebiyatı",

    "Fecr-i Âti Edebiyatı",

    "Millî Edebiyat",


    // -------------------------
    // CUMHURİYET / MODERN
    // -------------------------

    "Cumhuriyet Dönemi Şiiri",

    "Saf Şiir",

    "Cumhuriyet Dönemi Hikâye ve Romanı",

    "Modern Türk Tiyatrosu",

    "Küçürek Hikâye",


    // -------------------------
    // TÜRK DÜNYASI
    // -------------------------

    "Türk Dünyası Edebiyatı",


    // -------------------------
    // KİŞİSEL / ÖĞRETİCİ
    // METİN TÜRLERİ
    // -------------------------

       "Anı, Biyografi ve Tezkire",

    "Günlük ve Gezi Yazısı",

    "Deneme, Eleştiri ve Makale",

    "Mektup, Mülakat ve Söyleşi"
  ],


  // ====================================================
  // TYT / TEMEL FİZİK
  // 9 + 10. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "TYT - Fizik": [

    // -------------------------
    // 9. SINIF
    // -------------------------

    "Fizik Bilimi ve Alt Dalları",

    "Fizik Bilimine Yön Verenler ve Kariyer Keşfi",

    "Temel ve Türetilmiş Nicelikler",

    "Skaler ve Vektörel Nicelikler",

    "Vektörler",

    "Doğadaki Temel Kuvvetler",

    "Hareketin Temel Kavramları ve Hareket Türleri",

    "Basınç",

    "Sıvılarda Basınç",

    "Açık Hava Basıncı",

    "Kaldırma Kuvveti",

    "Akışkanlarda Sürat ve Basınç İlişkisi",

    "İç Enerji, Isı ve Sıcaklık",

    "Isı, Öz Isı ve Isı Sığası",

    "Hâl Değişimi",

    "Isıl Denge",

    "Isı Aktarım Yolları ve Isı İletim Hızı",


    // -------------------------
    // 10. SINIF
    // -------------------------

    "Sabit Hızlı Hareket",

    "Bir Boyutta Sabit İvmeli Hareket",

    "İş, Enerji ve Güç",

    "Enerji Biçimleri",

    "Mekanik Enerji",

    "Enerji Kaynakları",

    "Basit Elektrik Devreleri",

    "Elektrik Akımı ve Ohm Yasası",

    "Dirençlerin Bağlanması",

    "Üreteçlerin Bağlanması",

    "Elektrik Güvenliği ve Topraklama",

    "Periyodik Hareketler",

    "Dalgaların Temel Kavramları ve Sınıflandırılması",

    "Dalgaların Yayılma Sürati",

    "Su Dalgalarında Yansıma ve Kırılma",

    "Rezonans ve Deprem"
  ],


  // ====================================================
  // AYT / İLERİ FİZİK
  // 11 + 12. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "AYT - Fizik (İleri)": [

    // -------------------------
    // 11. SINIF — KUVVET / HAREKET
    // -------------------------

    "Serbest Düşme",

    "İki Boyutta Sabit İvmeli Hareket",

    "Newton Hareket Yasaları",

    "Sürtünme Kuvveti",

    "Limit Hız",

    "Düzgün Çembersel Hareket",


    // -------------------------
    // 11. SINIF — ELEKTRİK / MANYETİZMA
    // -------------------------

    "Elektriksel Kuvvet ve Elektriksel Alan",

    "Manyetik Alan ve Manyetik Kuvvet",

    "Elektromanyetik İndüksiyon ve Alternatif Akım",

    "Transformatörler",


    // -------------------------
    // 11-12. SINIF — MADDE VE DOĞASI
    // -------------------------

    "Yarı İletkenler ve Süper İletkenler",


    // -------------------------
    // 11. SINIF — OPTİK
    // -------------------------

    "Işık Şiddeti, Işık Akısı ve Aydınlanma",

    "Düzlem Aynalar",

    "Küresel Aynalar",

    "Kırılma ve Tam Yansıma",

    "Görünür Derinlik",

    "Fiber Optik",

    "Prizmalar",

    "Mercekler",


    // -------------------------
    // 12. SINIF — KUVVET / HAREKET
    // -------------------------

    "Tork",

    "Denge, Kütle Merkezi ve Ağırlık Merkezi",

    "İtme ve Momentum",

    "Momentumun Korunumu",

    "Eylemsizlik Momenti",

    "Açısal Momentum",


    // -------------------------
    // 12. SINIF — ENERJİ
    // -------------------------

    "Yay Sabiti ve Hooke Yasası",

    "Esneklik Potansiyel Enerjisi",

    "Sürtünme Kuvvetinin Yaptığı İş",

    "Enerjinin Korunumu ve Verim",


    // -------------------------
    // 12. SINIF — DALGALAR
    // -------------------------

    "Su Dalgalarında Kırınım ve Girişim",

    "Işıkta Kırınım ve Girişim",

    "Elektromanyetik Dalgalar",

    "Işık Renkleri",


    // -------------------------
    // 12. SINIF — MODERN FİZİK
    // -------------------------

    "Siyah Cisim Işıması",

    "Fotoelektrik Etki",

        "Standart Model ve Temel Parçacıklar",

    "Modern Atom Teorisi",

    "Nükleer Enerji"
  ],


  // ====================================================
  // TYT / TEMEL KİMYA
  // 9 + 10. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "TYT - Kimya": [

    // -------------------------
    // 9. SINIF — KİMYA HAYATTIR
    // -------------------------

    "Günlük Hayatta Kimya",

    "Kimyasal Maddelerin Kullanımı ve Güvenlik",

    "Kimyanın Alt Disiplinleri ve Kariyer Olanakları",


    // -------------------------
    // 9. SINIF — ATOM / PERİYODİK TABLO
    // -------------------------

    "Atom Teorileri ve Atomun Yapısı",

    "Atom Orbitalleri ve Elektron Dizilimi",

    "Periyodik Tabloda Yer Bulma",

    "İyon Oluşumu",

    "Periyodik Özellikler",


    // -------------------------
    // 9. SINIF — KİMYASAL BAĞLAR
    // -------------------------

    "Metalik Bağ",

    "İyonik Bağ",

    "Kovalent Bağ",

    "Lewis Nokta Yapısı",

    "Molekül Polarlığı ve Apolarlığı",

    "Bileşiklerin Adlandırılması",


    // -------------------------
    // 9. SINIF — MADDELER ARASI ETKİLEŞİMLER
    // -------------------------

    "Moleküller Arası Etkileşimler",

    "Katılar ve Özellikleri",

    "Sıvılar ve Özellikleri",

    "Metal Nanoparçacıklar ve Ekolojik Sürdürülebilirlik",


    // -------------------------
    // 10. SINIF — KİMYASAL TEPKİMELER
    // -------------------------

    "Kimyasal Değişim ve Kimyasal Tepkimeler",

    "Kimyasal Tepkime Türleri",

    "Mol Kavramı",

    "Kimyasal Tepkime Denklemlerinin Denkleştirilmesi",

    "Stokiyometrik Hesaplamalar",


    // -------------------------
    // 10. SINIF — GAZLAR
    // -------------------------

    "Gazların Özellikleri ve Kinetik Moleküler Teori",

    "Gaz Yasaları",

    "İdeal Gaz Yasası",

    "Difüzyon ve Efüzyon",


    // -------------------------
    // 10. SINIF — ÇÖZELTİLER
    // -------------------------

    "Çözünme Süreci ve Çözünebilirlik",

    "Çözünürlük ve Çözünürlüğe Etki Eden Faktörler",

    "Çözeltilerin Sınıflandırılması",

    "Derişim Birimleri: Molarite ve ppm",

    "Koligatif Özellikler",


    // -------------------------
    // 10. SINIF — SÜRDÜRÜLEBİLİRLİK
    // -------------------------

    "Yeşil Kimya ve Atom Ekonomisi",

    "Atmosferdeki Tepkimeler ve Küresel Sorunlar"
  ],


  // ====================================================
  // AYT / İLERİ KİMYA
  // 11 + 12. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "AYT - Kimya (İleri)": [

    // -------------------------
    // 11. SINIF — ENERJİ
    // -------------------------

    "Tepkimelerde Enerji Değişimi ve Entalpi",

    "Bağ Enerjileriyle Tepkime Entalpisi",

    "Standart Oluşum Entalpileri",


    // -------------------------
    // 11. SINIF — TEPKİME HIZI
    // -------------------------

    "Kimyasal Tepkimelerde Hız",

    "Tepkime Hızına Etki Eden Faktörler",

    "Çarpışma Teorisi ve Aktivasyon Enerjisi",

    "Tepkime Hız Denklemi ve Tepkime Derecesi",


    // -------------------------
    // 11. SINIF — KİMYASAL DENGE
    // -------------------------

    "Kimyasal Denge ve Denge Sabiti",

    "Tepkime Oranı ve Denge Yönü",

    "Dengeye Etki Eden Faktörler ve Le Chatelier İlkesi",


    // -------------------------
    // 11. SINIF — ASİT / BAZ DENGESİ
    // -------------------------

    "Suyun Otoiyonizasyonu ve pH-pOH",

    "Asit-Baz Teorileri",

    "Kuvvetli ve Zayıf Asit-Baz Dengeleri",

    "Nötralleşme ve Titrasyon",


    // -------------------------
    // 11. SINIF — ÇÖZÜNÜRLÜK DENGESİ
    // -------------------------

    "Molar Çözünürlük ve Çözünürlük Çarpımı",

    "Ortak İyon Etkisi ve Çözünürlük Dengesi",


    // -------------------------
    // 11. SINIF — SÜRDÜRÜLEBİLİRLİK
    // -------------------------

    "Nanoteknoloji ve Sürdürülebilirlik",

    "Yeşil Hidrojen Enerjisi",

    "Mikroplastikler ve Nanoplastikler",


    // -------------------------
    // 12. SINIF — ELEKTROKİMYA
    // -------------------------

    "İndirgenme-Yükseltgenme Tepkimeleri",

    "Metallerin Aktifliği",

    "Galvanik Hücreler",

    "Standart Hücre Potansiyeli",

    "Hücre Potansiyelini Etkileyen Faktörler",

    "Elektrolitik Hücreler ve Elektroliz",

    "Elektroliz Hesaplamaları",

    "Elektrolizle Kaplama ve Korozyon",


    // -------------------------
    // 12. SINIF — ORGANİK KİMYA
    // -------------------------

    "Sigma ve Pi Bağları",

    "Hibritleşme, Molekül Geometrisi ve VSEPR",

    "Organik Bileşiklerin Yapı Formülleri",

    "Alifatik ve Aromatik Hidrokarbonlar",

    "Hidrokarbonların Sınıflandırılması ve Adlandırılması",

    "Hidrokarbonlarda İzomerlik",

    "Hidrokarbonların Fiziksel ve Kimyasal Özellikleri",

    "Organik Bileşiklerde Fonksiyonel Gruplar",

    "Fonksiyonel Gruplu Organik Bileşiklerin Adlandırılması",

    "Fonksiyonel Grup İzomerliği",

    "Karbon Temelli Enerji Kaynakları",


    // -------------------------
    // 12. SINIF — NANOBİLİM / YEŞİL KİMYA
    // -------------------------

    "Nanobilim, Yeşil Kimya ve Sürdürülebilirlik",

        "Boyaya Duyarlı Güneş Pilleri",

    "Biyobozunur Polimerler",

    "Yapay Zekâ ve Sürdürülebilirlik"
  ],


  // ====================================================
  // TYT / TEMEL BİYOLOJİ
  // 9 + 10. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "TYT - Biyoloji": [

    // -------------------------
    // 9. SINIF — YAŞAM
    // -------------------------

    "Biyoloji Bilimi ve Bilimin Doğası",

    "Bilimsel Araştırma Süreçleri ve Bilim Etiği",

    "Canlıların Ortak Özellikleri",

    "Virüsler",

    "İnorganik Moleküller",

    "Organik Moleküller",

    "Karbohidratlar, Lipitler ve Proteinler",

    "Enzimler ve Enzim Aktivitesine Etki Eden Faktörler",


    // -------------------------
    // 9. SINIF — ORGANİZASYON
    // -------------------------

    "Prokaryot ve Ökaryot Hücre",

    "Hücre Zarı, Sitoplazma ve Organeller",

    "Hücre Zarından Madde Geçişleri",

    "Difüzyon ve Ozmoz",

    "Aktif Taşıma, Endositoz ve Ekzositoz",

    "Canlıların Sınıflandırılması",

    "Modern Sınıflandırma ve İkili Adlandırma",

    "Üç Üst Âlem (Domain) Sistemi",

    "Biyoçeşitlilik",


    // -------------------------
    // 10. SINIF — ENERJİ
    // -------------------------

    "ATP ve Canlılarda Enerji",

    "Fotosentez",

    "Fotosentez Hızına Etki Eden Faktörler",

    "Kemosentez",

    "Canlılarda Sindirim Çeşitleri",

    "İnsanda Sindirim, Emilim ve Taşıma",

    "Hücresel Solunum",

    "Besinlerin Hücresel Solunuma Katılma Yolları",

    "Fermantasyon",

    "Enerji ve Metabolizma İlişkisi",


    // -------------------------
    // 10. SINIF — EKOLOJİ
    // -------------------------

    "Ekosistemin Canlı ve Cansız Bileşenleri",

    "Popülasyon ve Komünite",

    "Tür İçi ve Türler Arası Etkileşimler",

    "Süksesyon",

    "Popülasyon Dinamikleri",

    "Besin Zinciri ve Besin Ağı",

    "Ekolojik Piramitler",

    "Biyolojik Birikim",

    "Ekosistemde Enerji Akışı",

    "Su, Karbon ve Azot Döngüleri",

    "Ekolojik Sürdürülebilirlik",

    "Ekolojik Ayak İzi",

    "Doğal Kaynakların ve Biyoçeşitliliğin Korunması",

    "Atık Yönetimi"
  ],


  // ====================================================
  // AYT / İLERİ BİYOLOJİ
  // 11 + 12. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "AYT - Biyoloji (İleri)": [

    // -------------------------
    // 11. SINIF — TEPKİ
    // -------------------------

    "Canlılarda Uyaran ve Tepki",

    "Bitkisel Hormonlar",

    "Bitkilerde Tropizma ve Nasti",

    "Duyu Reseptörleri ve Duyu Organları",

    "Nöron Yapısı ve Sinirsel İletim",

    "Sinaps",

    "İnsan Sinir Sistemi",

    "Refleks",

    "Destek ve Hareket Sistemi",

    "Kasların Yapısı ve Kasılma Mekanizması",

    "Bağışıklık Sistemi",

    "Alerji ve Alerjik Tepkiler",


    // -------------------------
    // 11. SINIF — HOMEOSTAZİ
    // -------------------------

    "Homeostazi",

    "Homeostatik Süreçler",

    "Pozitif ve Negatif Geri Bildirim",

    "Sinir Sistemi ve Homeostazi",

    "Endokrin Sistem ve Homeostazi",

    "Dolaşım Sistemi ve Homeostazi",

    "Solunum Sistemi ve Homeostazi",

    "Boşaltım Sistemi ve Homeostazi",

    "Nefronun Yapısı ve Görevleri",

    "Sistemlerin Eş Güdümlü Çalışması",

    "Homeostazi Bozuklukları",


    // -------------------------
    // 12. SINIF — HÜCRE BÖLÜNMESİ / ÜREME
    // -------------------------

    "Kromozom Yapısı ve Genetik Materyalin Organizasyonu",

    "Hücre Döngüsü",

    "Mitoz",

    "Mayoz",

    "Kromozomlarda Ayrılmama",

    "Eşeysiz Üreme",

    "Eşeyli Üreme",

    "Gametogenez",

    "İnsanda Üreme Sistemi",

    "Menstrual Döngü ve Döllenme",

    "Embriyonik Gelişim",

    "Bitkilerde Eşeyli Üreme",

    "Tozlaşma, Döllenme, Tohum ve Meyve Oluşumu",

    "Çimlenme ve Dormansi",


    // -------------------------
    // 12. SINIF — GEN
    // -------------------------

    "DNA ve RNA'nın Moleküler Yapısı",

    "DNA Replikasyonu",

    "Gen ve Genetik Kod",

    "Transkripsiyon ve Translasyon",

    "Gen İfadesi",

    "Genetik Yapıdaki Değişiklikler",


    // -------------------------
    // 12. SINIF — KALITIM
    // -------------------------

    "Kalıtımın Temel İlkeleri",

    "Monohibrit Çaprazlama",

    "Dihibrit Çaprazlama",

    "Kontrol (Geri) Çaprazlaması",

    "Eş Baskınlık ve Çok Alellilik",

    "Eşeye Bağlı Kalıtım",

    "Soyağacı Analizi",

    "Genetik Testler ve Genetik Danışmanlık",


    // -------------------------
    // 12. SINIF — BİYOTEKNOLOJİ
    // -------------------------

    "Biyoteknoloji",

    "Rekombinant DNA Teknolojisi",

    "Kök Hücre ve Hücre Kültürü",

    "Gen Aktarımı",

    "Bitki Doku Kültürü",

    "Biyoteknolojinin Tıp, Tarım ve Endüstri Uygulamaları",

        "Biyoteknoloji ve Etik"
  ],


  // ====================================================
  // TYT / TEMEL TARİH
  // 9 + 10. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "TYT - Tarih": [

    // -------------------------
    // 9. SINIF — TARİH BİLİMİ
    // -------------------------

    "Tarih Biliminin Doğası ve Tarih Öğrenmenin Önemi",

    "Tarihsel Bilginin Üretim Süreci",

    "Tarih Araştırmalarında Kaynaklar ve Dijitalleşme",


    // -------------------------
    // 9. SINIF — ESKİ ÇAĞ
    // -------------------------

    "Tarım Devrimi ve İlk Yerleşimler",

    "Eski Çağ Medeniyetlerinde Yönetim ve Ordu",

    "Eski Çağ Medeniyetlerinde Hukuk",

    "Eski Çağ'da İnanç, Bilim ve Sanat",

    "İlk Türklerde Konargöçer Yaşam",


    // -------------------------
    // 9. SINIF — ORTA ÇAĞ
    // -------------------------

    "Orta Çağ'da Kitlesel Göçler",

    "Orta Çağ Devletlerinde Yönetim ve Ordu",

    "Orta Çağ'da Ticaret Yolları",

    "Orta Çağ Medeniyet Havzalarında Bilim, Kültür ve Sanat",


    // -------------------------
    // 10. SINIF — TÜRKİSTAN'DAN TÜRKİYE'YE
    // -------------------------

    "Türkistan'dan Türkiye'ye Siyasi ve Askerî Mücadeleler",

    "Türk Devlet ve Ordu Teşkilatında Değişim ve Süreklilik",

    "Türklerin Sosyal Yaşamı ve Ekonomik Faaliyetleri",

    "Anadolu'nun Türkleşmesi ve İslamlaşması",

    "Türk-İslam Medeniyetinde Bilim, Kültür, Eğitim ve Sanat",


    // -------------------------
    // 10. SINIF — BEYLİKTEN DEVLETE OSMANLI
    // -------------------------

    "Osmanlı Devleti'nin Kuruluş Süreci",

    "Osmanlı'nın Anadolu ve Rumeli'deki Siyasi ve Askerî Mücadeleleri",

    "Osmanlı Devletleşmesi: Ordu, Hukuk ve Toprak Sistemi",

    "Osmanlı'da İskân ve İstimâlet Politikaları",

    "Osmanlı'da İlim ve İrfan Geleneği",


    // -------------------------
    // 10. SINIF — CİHAN DEVLETİ OSMANLI
    // -------------------------

    "İstanbul'un Fethi ve Osmanlı'nın Dünya Gücüne Dönüşmesi",

    "1453-1683 Osmanlı Siyasi ve Askerî Mücadeleleri",

    "Osmanlı Yönetim ve Ordu Yapısında Değişim",

    "Avrupa Sömürgeciliği ve Osmanlı'ya Etkileri",

    "Osmanlı'da İsyanlar",

    "Osmanlı'da Bilim, Kültür, Eğitim ve Sanat"
  ],


  // ====================================================
  // AYT / İLERİ TARİH
  // 11. sınıf Tarih + 12. sınıf T.C. İnkılap Tarihi
  // ====================================================

  "AYT - Tarih (İleri)": [

    // -------------------------
    // 11. SINIF — 1683-1789
    // -------------------------

    "1683-1789 Osmanlı Siyasi ve Askerî Mücadeleleri",

    "Lale Devri ve Osmanlı'da Değişim",

    "18. Yüzyıl Osmanlı Islahatları",

    "18. Yüzyılda Osmanlı Devlet ve Toplum Yapısı",


    // -------------------------
    // 11. SINIF — 1789-1908
    // -------------------------

    "Fransız İhtilali ve Osmanlı Devleti'ne Etkileri",

    "1789-1908 Osmanlı Siyasi, Askerî ve İdari Gelişmeleri",

    "Tanzimat ve Islahat Süreci",

    "Meşrutiyet ve Anayasal Gelişmeler",

    "Osmanlı'da Bilim, Sanat ve Teknoloji",

    "Osmanlı'nın Sanayileşme Çabaları",


    // -------------------------
    // 11. SINIF — 1908-1918
    // -------------------------

    "II. Meşrutiyet Dönemi",

    "Trablusgarp Savaşı ve Balkan Savaşları",

    "I. Dünya Savaşı'nda Osmanlı Devleti",

    "I. Dünya Savaşı'nın Osmanlı Devleti'ne Etkileri",


    // -------------------------
    // 12. SINIF — MODERN TÜRK DEVLETİNİN DOĞUŞU
    // -------------------------

    "Mustafa Kemal'in Kişilik Özellikleri ve Fikir Dünyası",

    "Millî Mücadele'nin Hazırlık Süreci",

    "Millî Mücadele Muharebeleri",

    "Millî Mücadele'de Diplomatik Zaferler",

    "Atatürk Dönemi İç Siyaseti",

    "Atatürk Dönemi Dış Politikası",


    // -------------------------
    // 12. SINIF — TÜRK İNKILABI
    // -------------------------

    "Türk İnkılabı ve Modernleşme",

    "Siyasi, Hukuki ve Toplumsal Alanda İnkılaplar",

    "Ekonomi, Eğitim, Bilim, Kültür ve Sağlık Alanında İnkılaplar",

    "Atatürk İlkeleri ve Atatürkçü Düşünce Sistemi",


    // -------------------------
    // 12. SINIF — II. DÜNYA SAVAŞI VE SONRASI
    // -------------------------

    "II. Dünya Savaşı'nın Nedenleri ve Sonuçları",

    "II. Dünya Savaşı Sürecinde Türkiye",

    "Soğuk Savaş Döneminde Türkiye'nin Dış Politikası",

    "Türkiye'de Demokratikleşme ve Siyasi Gelişmeler",

    "Türkiye'de Sosyal ve Ekonomik Gelişmeler",

    "Türkiye'de Bilim, Teknoloji, Kültür, Eğitim ve Spor",

    "Küreselleşme Sürecinde Türkiye"
  ],


  // ====================================================
  // TYT / TEMEL COĞRAFYA
  // 9 + 10. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "TYT - Coğrafya": [

    // -------------------------
    // 9. SINIF — COĞRAFYANIN DOĞASI / HARİTA
    // -------------------------

    "Coğrafyanın Konusu, Bölümleri ve Gelişimi",

    "Coğrafi Bakış ve Mekânsal Düşünme",

    "Harita Bilgisi",

    "Koordinat Sistemi ve Coğrafi Konum",

    "Türkiye'nin Coğrafi Konumu",

    "Mekânsal Bilgi Teknolojileri ve CBS",


    // -------------------------
    // 9. SINIF — DOĞAL SİSTEMLER
    // -------------------------

    "Hava Olayları",

    "İklim Sisteminin Bileşenleri",

    "İklim Elemanları",

    "Dünya'da İklim Tipleri",

    "İklim Değişikliği ve Süreklilik",


    // -------------------------
    // 9. SINIF — BEŞERÎ SİSTEMLER
    // -------------------------

    "Nüfusun Tarihsel Değişimi ve Demografik Dönüşüm",

    "Nüfusun Dağılışı ve Nüfus Dağılışını Etkileyen Faktörler",

    "Nüfus Piramitleri",

    "Nüfus Politikaları, Fırsatlar ve Sorunlar",


    // -------------------------
    // 9. SINIF — EKONOMİ / AFET / BÖLGE
    // -------------------------

    "Ekonomik Faaliyetleri Etkileyen Coğrafi Faktörler",

    "Tehlike, Risk ve Afet",

    "Afet Türleri",

    "Bütüncül Afet Yönetimi",

    "Bölge Kavramı ve Bölge Belirleme Kriterleri",

    "Bölge Türleri ve Bölge Sınırlarının Değişimi",


    // -------------------------
    // 10. SINIF — MEKÂNSAL BİLGİ TEKNOLOJİLERİ
    // -------------------------

    "Uzaktan Algılama ve CBS Uygulamaları",


    // -------------------------
    // 10. SINIF — DOĞAL SİSTEMLER
    // -------------------------

    "Levha Tektoniği",

    "Jeolojik Zamanlar ve Kayaç Döngüsü",

    "İç Kuvvetler ve Yeryüzü Şekilleri",

    "Aşınma, Çözünme, Taşınma ve Birikim",

    "Dış Kuvvetler ve Oluşturdukları Yer Şekilleri",

    "Yeryüzü Şekilleri ile Beşerî Faaliyetler Arasındaki Etkileşim",


    // -------------------------
    // 10. SINIF — BEŞERÎ SİSTEMLER
    // -------------------------

    "Yerleşmelerin Kuruluş ve Gelişimini Etkileyen Faktörler",

    "Yerleşme Tipleri ve Fonksiyonları",

    "Türkiye'de Yerleşmeler",


    // -------------------------
    // 10. SINIF — EKONOMİ
    // -------------------------

    "Ekonomik Faaliyetlerin Sektörlere Göre Sınıflandırılması",

    "Ekonomik Sektörler ve Gelişmişlik",

    "Türkiye Ekonomisinin Sektörel Dağılımı",


    // -------------------------
    // 10. SINIF — AFET / TÜRK DÜNYASI
    // -------------------------

    "Afetlerle Mücadele ve Sürdürülebilir Çevre",

    "Türk Dünyasının Coğrafi Özellikleri",

    "Türk Dünyasının Kültürel Özellikleri"
  ],


  // ====================================================
  // AYT / İLERİ COĞRAFYA
  // 11 + 12. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "AYT - Coğrafya (İleri)": [

    // -------------------------
    // 11. SINIF — MEKÂNSAL TEKNOLOJİ / DOĞAL SİSTEMLER
    // -------------------------

    "Mekânsal Sorunlar Karşısında Coğrafya Bilimi",

    "Web Tabanlı CBS Uygulamaları",

    "Türkiye ve Dünya'da Su Kaynakları",

    "Su Kaynaklarının Sürdürülebilir Kullanımı",

    "Toprak Oluşumu, Toprak Türleri ve Toprak Dağılışı",


    // -------------------------
    // 11. SINIF — BEŞERÎ SİSTEMLER
    // -------------------------

    "Yerleşmelerin Mekânsal Organizasyonu",

    "Yerleşmelerin Etki Alanları",

    "Şehirlerin Fonksiyonları ve Etki Alanları",


    // -------------------------
    // 11. SINIF — EKONOMİ
    // -------------------------

    "Doğal Kaynaklar ve Ekonomik Faaliyetler",

    "Türkiye'de Tarım ve Hayvancılık",

    "Türkiye'de Sanayi",

    "Türkiye'de Ulaşım, Ticaret ve Turizm",

    "Bölgesel Kalkınma ve Ekonomik Farklılıklar",


    // -------------------------
    // 11. SINIF — SÜRDÜRÜLEBİLİRLİK / KÜRESEL BAĞLANTILAR
    // -------------------------

    "Gezegen Sınırları",

    "Küresel İklim Değişikliğine Uyum",

    "Türkiye'de Suyun Sürdürülebilir Kullanımı",

    "Türkiye'nin Kültürel Hinterlandı",

    "Ülkelerin Tarımsal Üretim Özellikleri",

    "Ülkelerin Sanayileşme Süreçleri",

    "Dünya'da Madencilik ve Enerji Kaynakları",


    // -------------------------
    // 12. SINIF — DOĞAL SİSTEMLER
    // -------------------------

    "Ekosistemler ve Biyomlar",

    "Türkiye ve Dünya'da Bitki Örtüsünün Dağılışı",

    "Doğal Sistemlerde Değişim ve İnsan Etkisi",


    // -------------------------
    // 12. SINIF — BEŞERÎ / EKONOMİK SİSTEMLER
    // -------------------------

    "Nüfus, Yerleşme ve Ekonomik Faaliyetlerin Geleceği",

    "Türkiye'nin Ekonomik Coğrafyası",

    "Küresel Ticaret ve Ulaşım Ağları",

    "Turizm ve Küresel Etkileşim",

    "Enerji Kaynakları ve Enerji Politikaları",


    // -------------------------
    // 12. SINIF — ÇEVRE / KÜRESEL BAĞLANTILAR
    // -------------------------

    "Çevre Sorunları ve Sürdürülebilirlik",

    "Afet Risklerinin Azaltılması ve Dirençlilik",

    "İklim Değişikliği ve Uyum Politikaları",

    "Bölgesel ve Küresel Örgütler",

    "Jeopolitik Konum ve Küresel Güç İlişkileri",

        "Türkiye'nin Bölgesel ve Küresel Bağlantıları"
  ],


  // ====================================================
  // TYT / FELSEFE
  //
  // TYMM 10-11. sınıf Felsefe programının
  // Rehber360 koçluk konu havuzuna dönüştürülmüş hâli.
  // ====================================================

  "TYT - Felsefe": [

    // -------------------------
    // 10. SINIF
    // -------------------------

    "Felsefenin Doğası",

    "Felsefenin Anlamı, Gelişimi ve İşlevi",

    "Felsefi Düşüncenin Özellikleri",

    "Felsefe, Mantık ve Argümantasyon",

    "Varlık Felsefesi",

    "Bilgi Felsefesi",

    "Ahlak Felsefesi",

    "Estetik ve Sanat Felsefesi",

    "Siyaset Felsefesi",

    "Din Felsefesi",

    "Bilim Felsefesi",


    // -------------------------
    // 11. SINIF
    // -------------------------

    "Çevre Sorunları ve Felsefe",

    "Teknoloji ve Hayat",

    "Akıl ve İnanç",

    "Edebiyat ve Felsefe",

    "Hayatın Anlamı",

    "Hukuk ve Felsefe"
  ],


  // ====================================================
  // TYT / DİN KÜLTÜRÜ
  // 9 + 10. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "TYT - Din Kültürü": [

    // -------------------------
    // 9. SINIF
    // -------------------------

    "Allah-İnsan İlişkisi",

    "İslam'da İnanç Esasları",

    "İslam'da İbadetler",

    "İslam'da Ahlak İlkeleri",

    "Kur'an'a Göre Hz. Muhammed",


    // -------------------------
    // 10. SINIF
    // -------------------------

    "İslam'da Varlık ve Bilgi",

    "Allah'ı Tanımak",

    "İslam'ın Evrensel Mesajları",

    "Din, Çevre ve Teknoloji",

    "İslam Düşüncesinde İtikadi-Siyasi ve Fıkhi Yorumlar"
  ],


  // ====================================================
  // AYT / PSİKOLOJİ
  // TYMM ortaöğretim seçmeli Psikoloji programı
  // ====================================================

  "AYT - Psikoloji": [

    "Psikoloji ile Tanışma",

    "Psikolojinin Tanımı, Konusu ve Amaçları",

    "Psikolojinin Alt Dalları",

    "Psikolojinin Yöntem ve Teknikleri",

    "Gelişimi Anlamak",

    "Gelişimin Temel Kavramları ve İlkeleri",

    "Gelişimi Etkileyen Etmenler",

    "Gelişim Dönemleri",

    "Zekâ, Kişilik ve Benlik",

    "Nasıl Öğreniriz?",

    "Öğrenmenin Temel Kavramları",

    "Öğrenmeyi Etkileyen Etmenler",

    "Öğrenme Yaklaşımları",

    "İnsan Öğrenmesi ve Makine Öğrenmesi",

    "Bireysel ve Sosyal Uyum",

    "Uyum Sorunları ve Uyum Becerileri"
  ],


  // ====================================================
  // AYT / SOSYOLOJİ
  // TYMM ortaöğretim seçmeli Sosyoloji programı
  // ====================================================

  "AYT - Sosyoloji": [

    "Sosyolojinin Doğuşu",

    "Sosyolojik Düşünme ve Araştırma Yöntemleri",

    "Türkiye'de Modernleşme ve Sosyoloji",

    "Türkiye'de Sosyolojinin Gelişimi",

    "Kültür ve Toplumsal Yapı",

    "Toplumsal Kurumlar",

    "Güncel Sosyolojik Meseleler",

    "Bilim Sosyolojisi",

    "Örnek Sosyolojik Uygulamalar"
  ],


  // ====================================================
  // AYT / MANTIK
  // TYMM ortaöğretim seçmeli Mantık programı
  // ====================================================

  "AYT - Mantık": [

    "Mantığın Doğası",

    "Mantığın Tarihsel Gelişimi",

    "Mantığın Temel Kavramları",

    "Tümce, Önerme, Yargı ve Çıkarım",

    "Aristotelesçi Mantık",

    "Terimler",

    "Önermeler ve Önermeler Arası İlişkiler",

    "Çıkarım Çeşitleri",

    "Sembolik Mantık",

    "Doğruluk Değeri Tabloları",

    "Tutarlılık, Geçerlilik ve Eşdeğerlik",

    "Niceleme Mantığı",

    "Mantık Çeşitleri ve Uygulamaları",

    "Akıl Yürütme Biçimleri ve Mantıksal Denetleme"
  ],


  // ====================================================
  // AYT / DİN KÜLTÜRÜ
  // 11 + 12. sınıf ağırlıklı TYMM içeriği
  // ====================================================

  "AYT - Din Kültürü (İleri)": [

    // -------------------------
    // 11. SINIF
    // -------------------------

    "Kader, İrade ve Sorumluluk",

    "Din, Felsefe, Bilim ve Sanat",

    "İslam Medeniyeti ve Gönül Coğrafyamız",

    "İnançla İlgili Meseleler",

    "Yahudilik ve Hristiyanlık",


    // -------------------------
    // 12. SINIF
    // -------------------------

    "Kur'an-ı Kerim",

    "Din ve Aile",

    "Güncel Dinî Meseleler",

    "İslam Düşüncesinde Tasavvufi Yorumlar",

    "Hint ve Çin Dinleri"
  ]
};


// ======================================================
// KAYNAK VE YAYIN HAVUZU
// Kolay - Orta - Zor
// ======================================================

export const kaynaklarHavuzu = {
  "TYT - Türkçe": {
    "Kolay": [
      "Karekök O'dan TYT Türkçe",
      "Hız ve Renk TYT Türkçe",
      "ENS TYT Türkçe Destek Soru Bankası",
      "Benim Hocam TYT Türkçe Soru Bankası",
      "Miray TYT Türkçe Soru Bankası",
      "Paraf TYT Türkçe Soru Bankası"
    ],
    "Orta": [
      "345 TYT Türkçe",
      "Bilgi Sarmal TYT Türkçe",
      "Metin TYT Türkçe Soru Bankası",
      "Rasyonel TYT Türkçe Soru Bankası",
      "Toprak TYT Türkçe Soru Bankası",
      "Aydın TYT Türkçe Soru Bankası",
      "Oksijen TYT Türkçe Soru Bankası",
      "Süre TYT Türkçe Soru Bankası",
      "Yayın Denizi TYT Türkçe Soru Bankası",
      "Endemik TYT Türkçe Soru Bankası"
    ],
    "Zor": [
      "Limit TYT Türkçe",
      "Acil TYT Türkçe",
      "3D TYT Türkçe Soru Bankası",
      "Apotemi TYT Türkçe Soru Bankası",
      "Oksijen PRO TYT Türkçe Soru Bankası",
      "Bilgi Sarmal TYT Türkçe Soru Bankası"
    ]
  },

  "TYT - Matematik": {
    "Kolay": [
      "Karekök O'dan TYT Mat",
      "Mikro Orijinal TYT Mat",
      "Karekök TYT Sıfırdan Sınava Matematik Soru Bankası",
      "Aktif TYT Matematik Sıfırdan Başlayanlara",
      "Acil TYT Matematik İlaç Serisi",
      "ENS TYT Matematik Destek Soru Bankası",
      "Miray Öğren Pekiştir TYT Matematik Konu Özetli Soru Bankası",
      "Benim Hocam TYT Matematik Video Çözümlü Soru Bankası",
      "Hız ve Renk TYT Matematik Soru Bankası"
    ],
    "Orta": [
      "345 TYT Matematik",
      "Bilgi Sarmal TYT Matematik",
      "ENS TYT Matematik Soru Bankası",
      "Rasyonel TYT Matematik Yeni Nesil Soru Bankası",
      "Endemik TYT Matematik Soru Bankası",
      "Miray TYT Matematik Soru Bankası",
      "Aydın TYT Matematik Soru Bankası",
      "Toprak TYT Matematik Soru Bankası",
      "Oksijen TYT Matematik Soru Bankası",
      "Acil TYT Matematik Kurs Soru Bankası",
      "Limit TYT Matematik Soru Bankası",
      "Full TYT Matematik Soru Bankası"
    ],
    "Zor": [
      "3D TYT Matematik",
      "Acil TYT Matematik",
      "Orijinal TYT Matematik Soru Bankası",
      "Barış TYT Matematik Soru Bankası",
      "Metin TYT Matematik Soru Bankası",
      "Karekök TYT Matematik Soru Bankası",
      "Eyüp B TYT Matematik Soru Bankası"
    ]
  },

  "TYT - Geometri": {
    "Kolay": [
      "Karekök O'dan Geometri",
      "Bilgi Sarmal Temel Geometri",
      "Aktif TYT-AYT Geometri 0'dan Başlayanlara",
      "ENS TYT-AYT Geometri Destek Soru Bankası",
      "Mikro Orijinal TYT-AYT Geometri Soru Bankası",
      "Acil Geometri İlacı"
    ],
    "Orta": [
      "345 TYT Geometri",
      "Bilgi Sarmal TYT Geometri",
      "Karekök TYT-AYT Geometri Soru Bankası",
      "Aydın TYT-AYT Geometri Soru Bankası",
      "Endemik TYT-AYT Geometri Soru Bankası",
      "ÇAP TYT-AYT Plus Geometri Soru Bankası",
      "Full TYT-AYT Geometri Soru Bankası",
      "Hız ve Renk TYT-AYT Geometri Soru Bankası"
    ],
    "Zor": [
      "Orijinal TYT Geometri",
      "3D TYT Geometri",
      "Acil TYT-AYT Geometri Soru Bankası",
      "Barış TYT-AYT Geometri Soru Bankası",
      "Orijinal TYT-AYT Geometri Soru Bankası",
      "3D TYT-AYT Geometri Soru Bankası"
    ]
  },

  "TYT - Fizik": {
    "Kolay": [
      "Karekök O'dan Fizik",
      "Hız ve Renk TYT Fizik",
      "Aktif Öğrenme TYT Fizik Sıfırdan Başlayanlara",
      "Paraf TYT İşlemsiz Fizik",
      "Palme TYT Fizik Soru Bankası",
      "ENS TYT Fizik Destek Soru Bankası",
      "Limit TYT Temel Fizik Soru Bankası"
    ],
    "Orta": [
      "345 TYT Fizik",
      "3D TYT Fizik",
      "Bilgi Sarmal TYT Fizik Soru Bankası",
      "Aydın TYT Fizik Soru Bankası",
      "Miray TYT Fizik Soru Bankası",
      "Toprak TYT Fizik Soru Bankası",
      "Karaağaç TYT Fizik Soru Bankası",
      "Merkez TYT Fizik Soru Bankası",
      "Okyanus TYT Fizik Soru Bankası"
    ],
    "Zor": [
      "Acil TYT Fizik",
      "Orijinal TYT Fizik",
      "Nihat Bilgin TYT Fizik Soru Bankası",
      "ÇAP TYT Fizik Plus Soru Bankası",
      "3D TYT Fizik Soru Bankası",
      "Apotemi TYT Fizik Soru Bankası"
    ]
  },

  "TYT - Kimya": {
    "Kolay": [
      "Karekök O'dan Kimya",
      "Hız ve Renk TYT Kimya",
      "Aktif Öğrenme TYT Kimya Soru Bankası",
      "ENS TYT Kimya Destek Soru Bankası",
      "Palme TYT Kimya Soru Bankası",
      "Paraf TYT Kimya Soru Bankası"
    ],
    "Orta": [
      "345 TYT Kimya",
      "Palme TYT Kimya",
      "Bilgi Sarmal TYT Kimya Soru Bankası",
      "Orbital TYT Kimya Soru Bankası",
      "Endemik TYT Kimya Soru Bankası",
      "Miray TYT Kimya Soru Bankası",
      "Toprak TYT Kimya Soru Bankası",
      "Yayın Denizi Pro TYT Kimya Soru Bankası",
      "Okyanus TYT Kimya Soru Bankası"
    ],
    "Zor": [
      "3D TYT Kimya",
      "Acil TYT Kimya",
      "Aydın TYT Kimya Soru Bankası",
      "ÇAP TYT Kimya Plus Soru Bankası"
    ]
  },

  "TYT - Biyoloji": {
    "Kolay": [
      "Karekök O'dan Biyoloji",
      "Hız ve Renk TYT Biyoloji",
      "Aktif Öğrenme TYT Biyoloji Soru Bankası",
      "Dopamin TYT Biyoloji Soru Bankası",
      "Miray TYT Biyoloji Soru Bankası",
      "Oksijen TYT Biyoloji Soru Bankası",
      "Limit TYT Temel Biyoloji Soru Bankası"
    ],
    "Orta": [
      "345 TYT Biyoloji",
      "Palme TYT Biyoloji",
      "Biyotik TYT Biyoloji Soru Bankası",
      "Bilgi Sarmal TYT Biyoloji Soru Bankası",
      "Aydın TYT Biyoloji Soru Bankası",
      "Toprak TYT Biyoloji Soru Bankası",
      "Rasyonel TYT Biyoloji Soru Bankası",
      "Karekök TYT Biyoloji Soru Bankası",
      "Merkez TYT Biyoloji Soru Bankası"
    ],
    "Zor": [
      "3D TYT Biyoloji",
      "Acil TYT Biyoloji",
      "Apotemi TYT Biyoloji Soru Bankası",
      "ÇAP TYT Biyoloji Plus Soru Bankası",
      "Dr. Biyoloji TYT Soru Bankası"
    ]
  },

  "TYT - Tarih": {
    "Kolay": [
      "Hız ve Renk TYT Tarih",
      "Kafadengi TYT Tarih",
      "ENS TYT Tarih Destek Soru Bankası",
      "Merkez TYT Tarih Soru Bankası",
      "Benim Hocam TYT Tarih Soru Bankası",
      "Bilgi Arşivi TYT Tarih Soru Bankası"
    ],
    "Orta": [
      "345 TYT Tarih",
      "Bilgi Sarmal TYT Tarih",
      "Toprak TYT Tarih Soru Bankası",
      "ÇAP TYT Plus Tarih Soru Bankası",
      "ULTİ TYT Tarih Soru Bankası"
    ],
    "Zor": [
      "Limit TYT Tarih",
      "3D TYT Tarih"
    ]
  },

  "TYT - Coğrafya": {
    "Kolay": [
      "Hız ve Renk TYT Coğrafya",
      "Kafadengi TYT Coğrafya",
      "ENS TYT Coğrafya Destek Soru Bankası",
      "Ders Platosu TYT Coğrafya Sıfırmatik",
      "Merkez TYT Coğrafya Soru Bankası",
      "Coğrafya Gurmesi TYT Coğrafya 1. Aşama Soru Bankası"
    ],
    "Orta": [
      "345 TYT Coğrafya",
      "Palme TYT Coğrafya",
      "Bilgi Sarmal TYT Coğrafya Soru Bankası",
      "Coğrafya Gurmesi TYT Coğrafya Soru Bankası",
      "ÇAP TYT Plus Coğrafya Soru Bankası",
      "ULTİ TYT Coğrafya Soru Bankası",
      "Toprak TYT Coğrafya Soru Bankası"
    ],
    "Zor": [
      "Limit TYT Coğrafya",
      "3D TYT Coğrafya"
    ]
  },

  "TYT - Felsefe": {
    "Kolay": [
      "Kafadengi TYT Felsefe",
      "Hız ve Renk TYT Felsefe",
      "Hız ve Renk TYT Felsefe - Din Kültürü Soru Bankası",
      "Benim Hocam TYT Felsefe Soru Bankası"
    ],
    "Orta": [
      "345 TYT Felsefe",
      "Limit TYT Felsefe",
      "ÇAP TYT Felsefe Soru Bankası",
      "ULTİ TYT Felsefe Soru Bankası"
    ],
    "Zor": [
      "Acil TYT Felsefe",
      "Bilgi Sarmal TYT Felsefe"
    ]
  },

  "TYT - Din Kültürü": {
    "Kolay": [
      "Hız ve Renk TYT Din Kültürü",
      "Kafadengi TYT Din Kültürü",
      "Hız ve Renk TYT Felsefe - Din Kültürü Soru Bankası",
      "Benim Hocam TYT-AYT Din Kültürü ve Ahlak Bilgisi Soru Bankası"
    ],
    "Orta": [
      "345 TYT Din Kültürü",
      "Limit TYT Din Kültürü",
      "ÇAP TYT Din Kültürü Soru Bankası"
    ],
    "Zor": [
      "Acil TYT Din Kültürü",
      "Bilgi Sarmal TYT Din Kültürü"
    ]
  },

  "AYT - Matematik (İleri)": {
    "Kolay": [
      "Karekök O'dan AYT Mat",
      "Hız ve Renk AYT Mat",
      "Mikro Orijinal AYT Matematik Soru Bankası",
      "Ders Platosu AYT Matematik Sıfırmatik",
      "ENS AYT Matematik Destek Soru Bankası",
      "Aktif Öğrenme AYT Matematik Soru Bankası"
    ],
    "Orta": [
      "345 AYT Matematik",
      "Bilgi Sarmal AYT Mat",
      "Endemik AYT Matematik Soru Bankası",
      "Aydın AYT Matematik Soru Bankası",
      "Full AYT Matematik Soru Bankası",
      "Karekök AYT Matematik Soru Bankası",
      "Toprak AYT Matematik Soru Bankası",
      "Miray AYT Matematik Soru Bankası"
    ],
    "Zor": [
      "3D AYT Matematik",
      "Acil AYT Matematik",
      "Orijinal AYT Matematik Soru Bankası",
      "Barış AYT Matematik Soru Bankası",
      "Metin AYT Matematik Soru Bankası",
      "Eyüp B AYT Matematik Soru Bankası",
      "Ergi AYT Matematik Soru Bankası"
    ]
  },

  "AYT - Geometri (İleri)": {
    "Kolay": [
      "Karekök AYT Geometri",
      "Hız ve Renk AYT Geometri",
      "Aktif Öğrenme TYT-AYT Geometri 0'dan Başlayanlara",
      "ENS TYT-AYT Geometri Destek Soru Bankası"
    ],
    "Orta": [
      "345 AYT Geometri",
      "Bilgi Sarmal AYT Geometri",
      "ÇAP TYT-AYT Plus Geometri Soru Bankası",
      "Full TYT-AYT Geometri Soru Bankası",
      "Karekök TYT-AYT Geometri Soru Bankası",
      "Aydın TYT-AYT Geometri Soru Bankası",
      "Endemik TYT-AYT Geometri Soru Bankası"
    ],
    "Zor": [
      "Orijinal AYT Geometri",
      "Acil AYT Geometri",
      "3D TYT-AYT Geometri Soru Bankası",
      "Orijinal TYT-AYT Geometri Soru Bankası",
      "Barış TYT-AYT Geometri Soru Bankası"
    ]
  },

  "AYT - Edebiyat": {
    "Kolay": [
      "Kafadengi AYT Edebiyat",
      "ENS AYT Türk Dili ve Edebiyatı Destek Soru Bankası",
      "Ders Platosu AYT Edebiyat Sıfırmatik",
      "Süre AYT Şifreli Yorum Edebiyat",
      "Toprak AYT Edebiyat Soru Bankası",
      "Yayın Denizi AYT Edebiyat Soru Bankası",
      "Benim Hocam AYT Edebiyat Soru Bankası"
    ],
    "Orta": [
      "345 AYT Edebiyat",
      "Hız ve Renk AYT Edebiyat",
      "Endemik AYT Edebiyat Soru Bankası",
      "Edebiyat Sokağı AYT Edebiyat Soru Bankası",
      "Oksijen AYT Edebiyat Soru Bankası"
    ],
    "Zor": [
      "Bilgi Sarmal AYT Edebiyat",
      "Limit AYT Edebiyat",
      "3D AYT Edebiyat Soru Bankası",
      "Paragrafın Şifresi AYT Edebiyat Soru Bankası"
    ]
  },

  "AYT - Fizik (İleri)": {
    "Kolay": [
      "Karekök AYT Fizik",
      "Aktif Öğrenme AYT Fizik Sıfırdan Başlayanlara",
      "Paraf AYT İşlemsiz Fizik",
      "Limit AYT Fizik Soru Bankası",
      "Karaağaç AYT Fizik 0 Serisi"
    ],
    "Orta": [
      "345 AYT Fizik",
      "Hız ve Renk AYT Fizik",
      "Nihat Bilgin AYT Fizik",
      "Bilgi Sarmal AYT Fizik Soru Bankası",
      "Toprak AYT Fizik Soru Bankası",
      "Rasyonel AYT Fizik Soru Bankası",
      "Miray AYT Fizik Soru Bankası",
      "Palme AYT Fizik Soru Bankası",
      "Aromat AYT Fizik Soru Bankası",
      "Yayın Denizi Pro AYT Fizik Soru Bankası",
      "Egzersiz AYT Fizik Soru Bankası"
    ],
    "Zor": [
      "3D AYT Fizik",
      "Acil AYT Fizik",
      "Aydın AYT Fizik Soru Bankası",
      "Apotemi AYT Fizik Soru Bankası",
      "Karaağaç AYT Fizik Soru Bankası"
    ]
  },

  "AYT - Kimya (İleri)": {
    "Kolay": [
      "Karekök AYT Kimya",
      "Paraf AYT Kimya Soru Bankası",
      "Aktif Öğrenme AYT Kimya Soru Bankası",
      "ENS AYT Kimya Destek Soru Bankası"
    ],
    "Orta": [
      "Hız ve Renk AYT Kimya",
      "Orbital AYT Kimya Soru Bankası",
      "Bilgi Sarmal AYT Kimya Soru Bankası",
      "345 AYT Kimya Soru Bankası",
      "Endemik AYT Kimya Soru Bankası",
      "Palme AYT Kimya Soru Bankası",
      "Miray AYT Kimya Soru Bankası",
      "Yayın Denizi Pro AYT Kimya Soru Bankası",
      "Toprak AYT Kimya Soru Bankası"
    ],
    "Zor": [
      "3D AYT Kimya",
      "Limit AYT Kimya",
      "Aydın AYT Kimya"
    ]
  },

  "AYT - Biyoloji (İleri)": {
    "Kolay": [
      "Karekök AYT Biyoloji",
      "Biyotik AYT Biyoloji",
      "Miray AYT Biyoloji Soru Bankası",
      "Bilgi Sarmal AYT Biyoloji Soru Bankası",
      "Benim Hocam AYT Biyoloji Soru Bankası"
    ],
    "Orta": [
      "Hız ve Renk AYT Biyoloji",
      "Palme AYT Biyoloji",
      "Biyoanaliz AYT Biyoloji Soru Bankası",
      "Oksijen AYT Biyoloji Soru Bankası",
      "Toprak AYT Biyoloji Soru Bankası",
      "Rasyonel AYT Biyoloji Soru Bankası",
      "Dr. Biyoloji AYT Soru Bankası",
      "Biyotik AYT Biyoloji Soru Bankası"
    ],
    "Zor": [
      "3D AYT Biyoloji",
      "Acil AYT Biyoloji",
      "Aydın AYT Biyoloji Soru Bankası",
      "345 AYT Biyoloji Soru Bankası",
      "Apotemi Modern Biyoloji",
      "3D AYT Biyoloji Sistemler Soru Bankası"
    ]
  },

  "AYT - Tarih (İleri)": {
    "Kolay": [
      "Hız ve Renk AYT Tarih",
      "Kafadengi AYT Tarih",
      "Benim Hocam AYT Tarih",
      "Merkez TYT-AYT Tarih Soru Bankası",
      "ENS AYT Tarih Destek Soru Bankası"
    ],
    "Orta": [
      "345 AYT Tarih",
      "Limit AYT Tarih",
      "Bilgi Sarmal AYT Tarih",
      "Toprak AYT Tarih Soru Bankası",
      "ÇAP AYT Tarih Soru Bankası"
    ],
    "Zor": [
      "Bilgi Sarmal AYT Tarih",
      "3D AYT Tarih",
      "ULTİ AYT Tarih Soru Bankası",
      "Limit AYT Tarih Soru Bankası"
    ]
  },

  "AYT - Coğrafya (İleri)": {
    "Kolay": [
      "Hız ve Renk AYT Coğrafya",
      "Kafadengi AYT Coğrafya",
      "Benim Hocam AYT Coğrafya",
      "ENS AYT Coğrafya Destek Defterim",
      "Ders Platosu AYT Coğrafya Sıfırmatik"
    ],
    "Orta": [
      "345 AYT Coğrafya",
      "Palme AYT Coğrafya",
      "Bilgi Sarmal AYT Coğrafya Soru Bankası",
      "Toprak AYT Coğrafya Soru Bankası",
      "Coğrafya Gurmesi AYT Coğrafya Soru Bankası",
      "ÇAP AYT Coğrafya Soru Bankası"
    ],
    "Zor": [
      "Limit AYT Coğrafya",
      "Bilgi Sarmal AYT Coğrafya",
      "3D AYT Coğrafya Soru Bankası",
      "345 AYT Coğrafya Soru Bankası"
    ]
  },

  "AYT - Psikoloji": {
    "Kolay": [
      "Hız ve Renk AYT Felsefe Grubu",
      "Benim Hocam AYT Felsefe Grubu",
      "ÇAP AYT Felsefe Plus Soru Bankası"
    ],
    "Orta": [
      "345 AYT Felsefe Grubu",
      "Limit AYT Felsefe Grubu",
      "ULTİ AYT Felsefe Grubu Soru Bankası"
    ],
    "Zor": [
      "Bilgi Sarmal AYT Felsefe Grubu",
      "Acil AYT Felsefe Grubu"
    ]
  },

  "AYT - Sosyoloji": {
    "Kolay": [
      "Hız ve Renk AYT Felsefe Grubu",
      "Benim Hocam AYT Felsefe Grubu",
      "ÇAP AYT Felsefe Plus Soru Bankası"
    ],
    "Orta": [
      "345 AYT Felsefe Grubu",
      "Limit AYT Felsefe Grubu",
      "ULTİ AYT Felsefe Grubu Soru Bankası"
    ],
    "Zor": [
      "Bilgi Sarmal AYT Felsefe Grubu",
      "Acil AYT Felsefe Grubu"
    ]
  },

  "AYT - Mantık": {
    "Kolay": [
      "Hız ve Renk AYT Felsefe Grubu",
      "Benim Hocam AYT Felsefe Grubu",
      "ÇAP AYT Felsefe Plus Soru Bankası"
    ],
    "Orta": [
      "345 AYT Felsefe Grubu",
      "Limit AYT Felsefe Grubu",
      "ULTİ AYT Felsefe Grubu Soru Bankası"
    ],
    "Zor": [
      "Bilgi Sarmal AYT Felsefe Grubu",
      "Acil AYT Felsefe Grubu"
    ]
  },

  "AYT - Din Kültürü (İleri)": {
    "Kolay": [
      "Hız ve Renk AYT Din Kültürü",
      "Benim Hocam AYT Din Kültürü",
      "Hız ve Renk AYT Felsefe ve Din Kültürü Soru Bankası"
    ],
    "Orta": [
      "345 AYT Din Kültürü",
      "Limit AYT Din Kültürü",
      "Bilgi Sarmal AYT Din Kültürü Soru Bankası",
      "ÇAP AYT Felsefe ve Din Kültürü Soru Bankası"
    ],
    "Zor": [
      "Bilgi Sarmal AYT Din Kültürü",
      "Acil AYT Din Kültürü",
      "Limit AYT Din Kültürü Soru Bankası"
    ]
  },

  "LGS - Türkçe": {
    "Kolay": [
      "Hız LGS Türkçe",
      "Arı LGS Türkçe",
      "IQ 8. Sınıf Türkçe Soru Bankası",
      "Fenomen Kök Türkçe Soru Bankası",
      "Ankara Yayıncılık 8. Sınıf Türkçe Soru Bankası"
    ],
    "Orta": [
      "Mozaik LGS Türkçe",
      "Okyanus Master Türkçe",
      "Fenomen A Türkçe Soru Bankası",
      "Nitelik 8. Sınıf Türkçe Soru Bankası",
      "Paraf LGS Türkçe Soru Bankası",
      "Tonguç LGS Türkçe Soru Bankası"
    ],
    "Zor": [
      "Sinan Kuzucu LGS Türkçe",
      "Fenomen LGS Türkçe Soru Bankası",
      "Nartest LGS Türkçe Soru Bankası"
    ]
  },

  "LGS - Matematik": {
    "Kolay": [
      "Hız LGS Matematik",
      "Arı LGS Matematik",
      "IQ 8. Sınıf Matematik Soru Bankası",
      "Karekök LGS Matematik Soru Bankası",
      "Fenomen Kök Matematik Soru Bankası"
    ],
    "Orta": [
      "Mozaik LGS Matematik",
      "Okyanus Master Mat",
      "Nitelik 8. Sınıf Matematik Soru Bankası",
      "Nartest LGS Matematik Soru Bankası",
      "Tonguç LGS Matematik Soru Bankası",
      "Ankara Yayıncılık LGS Matematik Soru Bankası"
    ],
    "Zor": [
      "Sinan Kuzucu LGS Mat",
      "Orijinal LGS Mat",
      "3D LGS Matematik Soru Bankası",
      "Paraf LGS Matematik Soru Bankası"
    ]
  },

  "LGS - Fen Bilimleri": {
    "Kolay": [
      "Hız LGS Fen",
      "Arı LGS Fen",
      "IQ 8. Sınıf Fen Bilimleri Soru Bankası",
      "Fenomen Kök Fen Bilimleri Soru Bankası",
      "Ankara Yayıncılık LGS Fen Bilimleri Soru Bankası"
    ],
    "Orta": [
      "Mozaik LGS Fen",
      "Okyanus Master Fen",
      "Fenomen A Fen Bilimleri Soru Bankası",
      "Nitelik 8. Sınıf Fen Bilimleri Soru Bankası",
      "Tonguç LGS Fen Bilimleri Soru Bankası",
      "Paraf LGS Fen Bilimleri Soru Bankası"
    ],
    "Zor": [
      "Sinan Kuzucu LGS Fen",
      "Nartest LGS Fen",
      "Fenomen LGS Fen Bilimleri Soru Bankası"
    ]
  },

  "LGS - İnkılap Tarihi": {
    "Kolay": [
      "Hız LGS İnkılap",
      "Arı LGS İnkılap",
      "IQ 8. Sınıf İnkılap Tarihi Soru Bankası",
      "Tonguç LGS İnkılap Tarihi Soru Bankası"
    ],
    "Orta": [
      "Mozaik LGS İnkılap",
      "Okyanus Master İnkılap",
      "Ankara Yayıncılık LGS İnkılap Tarihi Soru Bankası",
      "Nitelik LGS İnkılap Tarihi Soru Bankası",
      "Nartest LGS İnkılap Tarihi Soru Bankası"
    ],
    "Zor": [
      "Sinan Kuzucu LGS İnkılap",
      "Fenomen LGS İnkılap Tarihi Soru Bankası"
    ]
  },

  "LGS - İngilizce": {
    "Kolay": [
      "Hız LGS İngilizce",
      "Arı LGS İngilizce",
      "Fenomen LGS İngilizce Soru Bankası",
      "Tonguç LGS İngilizce Soru Bankası"
    ],
    "Orta": [
      "Mozaik LGS İngilizce",
      "Okyanus Master İngilizce",
      "Nartest LGS İngilizce Soru Bankası",
      "Ankara Yayıncılık LGS İngilizce Soru Bankası"
    ],
    "Zor": [
      "More&More LGS İngilizce",
      "Sinan Kuzucu LGS Sözel Soru Bankası"
    ]
  },

  "LGS - Din Kültürü": {
    "Kolay": [
      "Hız LGS Din Kültürü",
      "Arı LGS Din Kültürü",
      "DDY 8. Sınıf Din Kültürü Soru Bankası",
      "Tonguç LGS Din Kültürü Soru Bankası"
    ],
    "Orta": [
      "Mozaik LGS Din Kültürü",
      "Okyanus Master Din Kültürü",
      "Nartest LGS Din Kültürü Soru Bankası",
      "Ankara Yayıncılık LGS Din Kültürü Soru Bankası"
    ],
    "Zor": [
      "Sinan Kuzucu LGS Din Kültürü",
      "Fenomen LGS Din Kültürü Soru Bankası"
    ]
  }
};